import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const QueryProvider = ({ children }) => <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;

export default QueryProvider;
